import React from 'react';
import { Clock } from 'lucide-react';

const ContactsTab = ({ contacts }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div className="p-4 border-b border-gray-100">
        <h2 className="font-semibold text-gray-800">Contact Messages ({contacts.length})</h2>
        <p className="text-sm text-gray-500 mt-1">
          New messages are automatically sent to hola@pom-pm.com
        </p>
      </div>
      <div className="divide-y divide-gray-100">
        {contacts.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            No contact messages yet.
          </div>
        ) : (
          contacts.map((contact) => (
            <div key={contact.id} className="p-4 hover:bg-gray-50 transition-colors">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-medium text-gray-800">{contact.name}</h3>
                  <p className="text-sm text-teal-600">{contact.email}</p>
                  {contact.phone && (
                    <p className="text-sm text-gray-500">{contact.phone}</p>
                  )}
                </div>
                <div className="text-right">
                  {contact.propertyType && (
                    <span className="text-xs px-2 py-1 bg-amber-100 text-amber-700 rounded">
                      {contact.propertyType}
                    </span>
                  )}
                  <div className="flex items-center gap-1 text-xs text-gray-400 mt-2">
                    <Clock className="w-3 h-3" />
                    {new Date(contact.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>
              <p className="mt-3 text-gray-600 text-sm bg-gray-50 p-3 rounded-lg">
                {contact.message}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ContactsTab;
